/* ch-js-deploy 2026-07-24T20:42Z */
(function () {
  if (window.__SACH3_HUB_V3__) return;
  window.__SACH3_HUB_V3__ = true;
  var PLATFORM_LABELS = {
    instagram: 'Instagram',
    tiktok: 'TikTok',
    youtube: 'YouTube',
    facebook: 'Facebook',
    pinterest: 'Pinterest',
    linkedin: 'LinkedIn',
    twitch: 'Twitch',
    x: 'X',
    snapchat: 'Snapchat',
    threads: 'Threads',
    reddit: 'Reddit',
    discord: 'Discord',
    telegram: 'Telegram',
    blog: 'Blog',
    podcast: 'Podcast',
    website: 'Website',
    newsletter: 'Newsletter',
  };

  // --- Lokalisierung -------------------------------------------------------
  // Die Section rendert (aus den Locale-Patches, Sprache theme-gesteuert) ein
  // JSON-Wörterbuch in <script type="application/json" data-sach3-i18n>. Fehlt
  // es, greift der deutsche Fallback aus dem zweiten t()-Argument, sodass sich
  // das Verhalten bei fehlendem Dictionary nicht ändert.
  var I18N = (function () {
    try {
      var node = document.querySelector('[data-sach3-i18n]');
      if (!node) return {};
      var parsed = JSON.parse(node.textContent || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  })();

  function t(key, fallback) {
    var value = I18N[key];
    if (typeof value === 'string' && value && value.toLowerCase().indexOf('translation missing') < 0) {
      return value;
    }
    return fallback;
  }

  // Ersetzt {name}-Platzhalter in lokalisierten Strings.
  function tf(key, fallback, vars) {
    var template = t(key, fallback);
    if (!vars) return template;
    return template.replace(/\{(\w+)\}/g, function (m, name) {
      return Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : m;
    });
  }

  // Zahlen-/Datumsformat folgt der aktiven Sprache (Dictionary-Key oder <html lang>).
  var LOCALE =
    (typeof I18N._locale === 'string' && I18N._locale) ||
    (document.documentElement && document.documentElement.getAttribute('lang')) ||
    'de-DE';

  // --- Nicht-blockierende UI-Helfer (ersetzen alert()/confirm()) -----------
  function sach3ToastHost() {
    var host = document.querySelector('[data-sach3-toast-host]');
    if (!host) {
      host = document.createElement('div');
      host.setAttribute('data-sach3-toast-host', '');
      host.className = 'sach3__toast-host';
      host.setAttribute('aria-live', 'polite');
      host.setAttribute('role', 'status');
      document.body.appendChild(host);
    }
    return host;
  }

  function sach3Notify(message, ok) {
    if (!message) return;
    var host = sach3ToastHost();
    var toast = document.createElement('div');
    toast.className = 'sach3__toast' + (ok === false ? ' is-err' : ' is-ok');
    toast.setAttribute('role', ok === false ? 'alert' : 'status');
    toast.textContent = String(message);
    host.appendChild(toast);
    window.setTimeout(function () {
      toast.classList.add('is-leaving');
      window.setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 400);
    }, 5200);
  }

  // Inline-Bestätigung als Overlay (Promise<boolean>), tastaturbedienbar.
  function sach3Confirm(message) {
    return new Promise(function (resolve) {
      var overlay = document.createElement('div');
      overlay.className = 'sach3__confirm-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      var box = document.createElement('div');
      box.className = 'sach3__confirm-box';
      var text = document.createElement('p');
      text.className = 'sach3__confirm-text';
      text.textContent = String(message || t('confirm_default', 'Bist du sicher?'));
      var actions = document.createElement('div');
      actions.className = 'sach3__confirm-actions';
      var yes = document.createElement('button');
      yes.type = 'button';
      yes.className = 'sach3__btn sach3__btn--danger';
      yes.textContent = t('confirm_yes', 'Ja, trennen');
      var no = document.createElement('button');
      no.type = 'button';
      no.className = 'sach3__btn sach3__btn--ghost';
      no.textContent = t('cancel', 'Abbrechen');
      function close(result) {
        document.removeEventListener('keydown', onKey);
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        resolve(result);
      }
      function onKey(e) {
        if (e.key === 'Escape') close(false);
      }
      yes.addEventListener('click', function () { close(true); });
      no.addEventListener('click', function () { close(false); });
      overlay.addEventListener('click', function (e) { if (e.target === overlay) close(false); });
      document.addEventListener('keydown', onKey);
      actions.appendChild(no);
      actions.appendChild(yes);
      box.appendChild(text);
      box.appendChild(actions);
      overlay.appendChild(box);
      document.body.appendChild(overlay);
      no.focus();
    });
  }

  function normalizeUrl(raw) {
    var value = String(raw || '').trim();
    if (!value) return '';
    if (/\s/.test(value)) return '';
    if (!/^https?:\/\//i.test(value)) value = 'https://' + value;
    return value;
  }

  function buildLoginUrl(root) {
    var base = (root && root.getAttribute('data-sach3-login-url')) || '/account/login';
    var returnUrl =
      (root && root.getAttribute('data-sach3-hub-path')) ||
      window.location.pathname ||
      '/pages/creator-hub-live';
    try {
      var loginUrl = new URL(base, window.location.origin);
      loginUrl.searchParams.set('return_url', returnUrl);
      return loginUrl.toString();
    } catch (e) {
      return '/account/login?return_url=' + encodeURIComponent(returnUrl);
    }
  }

  function parsePublicProfileUrl(url) {
    try {
      var parsed = new URL(url);
      var host = parsed.hostname.toLowerCase().replace(/\.$/, '');
      if (
        !/^https?:$/.test(parsed.protocol) ||
        parsed.username ||
        parsed.password ||
        !host ||
        host === 'localhost' ||
        /^\d{1,3}(?:\.\d{1,3}){3}$/.test(host) ||
        host.includes(':') ||
        /\.(local|internal|localhost|test|example|invalid)$/.test(host)
      ) {
        return null;
      }
      if (!/^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[a-z]{2,63}|xn--[a-z0-9-]{2,59})$/i.test(host)) {
        return null;
      }
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function hostIs(host, domain) {
    return host === domain || host.endsWith('.' + domain);
  }

  function detectPlatform(url) {
    var parsed = parsePublicProfileUrl(url);
    if (!parsed) return null;
    var host = parsed.hostname.toLowerCase();
    if (hostIs(host, 'instagram.com') || hostIs(host, 'instagr.am')) return 'instagram';
    if (hostIs(host, 'tiktok.com')) return 'tiktok';
    if (hostIs(host, 'youtube.com') || hostIs(host, 'youtu.be')) return 'youtube';
    if (hostIs(host, 'facebook.com') || hostIs(host, 'fb.com') || hostIs(host, 'fb.watch')) return 'facebook';
    if (/^(?:[a-z0-9-]+\.)*pinterest\.(?:com|[a-z]{2,3})$/i.test(host)) return 'pinterest';
    if (hostIs(host, 'linkedin.com')) return 'linkedin';
    if (hostIs(host, 'twitch.tv')) return 'twitch';
    if (hostIs(host, 'x.com') || hostIs(host, 'twitter.com')) return 'x';
    if (hostIs(host, 'snapchat.com')) return 'snapchat';
    if (hostIs(host, 'threads.net')) return 'threads';
    if (hostIs(host, 'reddit.com')) return 'reddit';
    if (hostIs(host, 'discord.com') || hostIs(host, 'discordapp.com')) return 'discord';
    if (host === 't.me' || host === 'telegram.me') return 'telegram';
    if (hostIs(host, 'substack.com') || hostIs(host, 'beehiiv.com')) return 'newsletter';
    return 'website';
  }

  function extractHandle(url, platform) {
    try {
      var parsed = new URL(url);
      var parts = parsed.pathname.split('/').filter(Boolean).map(function (part) {
        return decodeURIComponent(part).trim();
      });
      var first = parts[0] || '';
      var lower = first.toLowerCase();
      var simple = function (value) { return '@' + String(value || '').replace(/^@/, ''); };
      if (platform === 'youtube') {
        if (hostIs(parsed.hostname, 'youtu.be')) return '';
        if (first.startsWith('@') && parts.length === 1) return simple(first);
        if (['c', 'channel', 'user'].includes(lower) && parts.length === 2) return simple(parts[1]);
        return '';
      }
      if (platform === 'instagram') {
        if (parts.length !== 1 || ['accounts', 'about', 'developer', 'directory', 'explore', 'p', 'reel', 'reels', 'stories', 'tv'].includes(lower)) return '';
        return simple(first);
      }
      if (platform === 'tiktok') {
        return parts.length === 1 && first.startsWith('@') && parsed.hostname !== 'vm.tiktok.com'
          ? simple(first)
          : '';
      }
      if (platform === 'facebook') {
        if (parts.length !== 1 || ['events', 'groups', 'help', 'login', 'marketplace', 'photo', 'profile.php', 'reel', 'share', 'stories', 'watch'].includes(lower)) return '';
        return simple(first);
      }
      if (platform === 'pinterest') {
        return parts.length === 1 && !['ideas', 'pin', 'search', 'today'].includes(lower) ? simple(first) : '';
      }
      if (platform === 'linkedin') {
        return parts.length === 2 && ['in', 'company', 'school'].includes(lower) ? simple(parts[1]) : '';
      }
      if (platform === 'twitch') {
        return parts.length === 1 && !['directory', 'downloads', 'inventory', 'jobs', 'settings', 'videos'].includes(lower)
          ? simple(first)
          : '';
      }
      if (platform === 'x') {
        return parts.length === 1 && !['compose', 'explore', 'home', 'i', 'intent', 'messages', 'notifications', 'search', 'settings'].includes(lower)
          ? simple(first)
          : '';
      }
      if (platform === 'snapchat') return parts.length === 2 && lower === 'add' ? simple(parts[1]) : '';
      if (platform === 'threads') return parts.length === 1 && !['activity', 'login', 'search', 'settings'].includes(lower) ? simple(first) : '';
      if (platform === 'reddit') return parts.length === 2 && ['user', 'u'].includes(lower) ? simple(parts[1]) : '';
      if (platform === 'discord') return parts.length === 2 && lower === 'users' && /^\d+$/.test(parts[1] || '') ? 'user:' + parts[1] : '';
      if (platform === 'telegram') return parts.length === 1 && !['addstickers', 'joinchat', 'proxy', 's', 'share'].includes(lower) ? simple(first) : '';
      return parsed.hostname.replace(/^www\./, '');
    } catch (e) {
      return '';
    }
  }

  function setLoading(form, loading) {
    var submit = form.querySelector('[data-sach3-profile-submit]');
    var loadingEl = form.querySelector('[data-sach3-profile-loading]');
    if (submit) {
      submit.disabled = loading;
      submit.setAttribute('aria-busy', loading ? 'true' : 'false');
    }
    if (loadingEl) loadingEl.hidden = !loading;
  }

  function getHubRoot(node) {
    return node && node.closest('.sach3--landing');
  }

  function fillApplyForm(root, detected, analysis) {
    var panel = root.querySelector('[data-sach3-apply-panel]');
    var form = root.querySelector('[data-sach3-apply-form]');
    var summary = root.querySelector('[data-sach3-apply-summary]');
    if (!form) return;
    var platformInput = form.querySelector('[data-sach3-apply-platform]') || form.platform;
    var handleInput = form.querySelector('[data-sach3-apply-handle]') || form.handle;
    var profileInput = form.querySelector('[data-sach3-apply-profile-url]') || form.profileUrl;
    if (detected.platform && platformInput) platformInput.value = detected.platform;
    if (detected.handle && handleInput) handleInput.value = detected.handle;
    if (detected.profileUrl && profileInput) profileInput.value = detected.profileUrl;
    var levelInput = form.querySelector('[data-sach3-suggested-level]');
    if (levelInput && analysis && analysis.level) levelInput.value = analysis.level;
    if (summary && analysis) {
      summary.hidden = false;
      summary.textContent = '';
      var suggestedLevel = document.createElement('strong');
      suggestedLevel.textContent = analysis.levelLabel || analysis.level || 'Creator';
      summary.appendChild(suggestedLevel);
      var summaryDetails = [
        analysis.commissionRate,
        detected.handle || analysis.handle,
        analysis.platformLabel || detected.platform,
      ].filter(Boolean);
      if (summaryDetails.length) {
        summary.appendChild(document.createTextNode(' · ' + summaryDetails.join(' · ')));
      }
    }
    if (panel) panel.hidden = false;
  }

  function renderPreview(root, analysis, detected) {
    var platformEl = root.querySelector('[data-sach3-result-platform]');
    var handleEl = root.querySelector('[data-sach3-result-handle]');
    var headlineEl = root.querySelector('[data-sach3-preview-headline]');
    var sublineEl = root.querySelector('[data-sach3-preview-subline]');
    var scoreEl = root.querySelector('[data-sach3-preview-score]');
    var levelEl = root.querySelector('[data-sach3-preview-level]');
    var rateEl = root.querySelector('[data-sach3-preview-rate]');
    var perksEl = root.querySelector('[data-sach3-preview-perks]');
    var signalsEl = root.querySelector('[data-sach3-preview-signals]');
    var nextEl = root.querySelector('[data-sach3-preview-next]');
    var result = root.querySelector('[data-sach3-profile-result]');
    var connected = root.querySelector('[data-sach3-connected-state]');

    if (connected) connected.hidden = true;
    if (platformEl) {
      platformEl.textContent =
        analysis.platformLabel +
        ' · ' +
        (analysis.profileVerified === false
          ? t('assessed_unverified', 'vorläufig eingeschätzt')
          : t('analyzed', 'analysiert'));
    }
    if (handleEl) handleEl.textContent = analysis.handle;
    if (headlineEl) headlineEl.textContent = analysis.headline;
    if (sublineEl) sublineEl.textContent = analysis.subline;
    if (scoreEl) scoreEl.textContent = String(analysis.profileScore);
    if (levelEl) levelEl.textContent = analysis.levelLabel;
    if (rateEl) rateEl.textContent = analysis.commissionRate;
    if (perksEl) {
      perksEl.innerHTML = '';
      (analysis.perks || []).forEach(function (perk) {
        var li = document.createElement('li');
        li.textContent = perk;
        perksEl.appendChild(li);
      });
    }
    if (signalsEl) {
      signalsEl.textContent = (analysis.signals || []).slice(0, 3).join(' · ');
    }
    if (nextEl) {
      nextEl.textContent =
        analysis.nextStep ||
        t('preview_next', 'Nur noch Name und E-Mail — dann ist deine Start-Stufe gespeichert.');
    }
    if (result) {
      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    fillApplyForm(root, detected, analysis);
  }

  function showConnected(root, message) {
    var panel = root.querySelector('[data-sach3-apply-panel]');
    var connected = root.querySelector('[data-sach3-connected-state]');
    var title = root.querySelector('[data-sach3-connected-title]');
    var body = root.querySelector('[data-sach3-connected-body]');
    var actions = root.querySelector('[data-sach3-connected-actions]');
    var loginReturn = root.querySelector('.sach3__login-return');

    if (panel) panel.hidden = true;
    if (loginReturn) loginReturn.hidden = true;
    if (connected) {
      if (title) title.textContent = message || t('connected_title', 'Profil verbunden und freigeschaltet');
      if (body) {
        body.textContent =
          root.getAttribute('data-sach3-customer') === '1'
            ? t('connected_body', 'Du bist im Creator Hub aktiv — scroll runter für dein Dashboard.')
            : t(
                'connected_body_guest',
                'Deine Start-Stufe ist gespeichert. Melde dich mit derselben E-Mail an, um dein Dashboard zu öffnen — kein Extra-Login nötig.'
              );
      }
      if (actions) {
        actions.innerHTML = '';
        if (root.getAttribute('data-sach3-customer') !== '1') {
          var login = document.createElement('a');
          login.href = buildLoginUrl(root);
          login.textContent = t('connected_login_cta', 'Jetzt anmelden →');
          actions.appendChild(login);
        } else {
          var dash = document.createElement('button');
          dash.type = 'button';
          dash.setAttribute('data-sach3-scroll-dashboard', '1');
          dash.textContent = t('connected_dashboard_cta', 'Zum Dashboard →');
          actions.appendChild(dash);
        }
        actions.hidden = false;
      }
      connected.hidden = false;
      connected.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    cleanUrlParams();
  }

  function cleanUrlParams() {
    try {
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', window.location.pathname);
      }
    } catch (e) {}
  }

  async function analyzeProfile(analyzeUrl, payload) {
    var controller = new AbortController();
    var timer = window.setTimeout(function () {
      controller.abort();
    }, 15000);
    var res;
    try {
      res = await fetch(analyzeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
        signal: controller.signal,
      });
    } catch (e) {
      window.clearTimeout(timer);
      throw new Error(t('connect_retry', 'Verbinden fehlgeschlagen — bitte erneut versuchen.'));
    }
    window.clearTimeout(timer);
    var data;
    try {
      data = await res.json();
    } catch (e) {
      throw new Error(t('unexpected_response', 'Unerwartete Antwort — bitte erneut versuchen.'));
    }
    if (!res.ok || !data || !data.success) {
      var msg = (data && data.error) || t('analyze_failed', 'Analyse fehlgeschlagen');
      // Safari: generische Pattern-Meldung nie roh anzeigen
      if (String(msg).toLowerCase().indexOf('expected pattern') >= 0) {
        msg = t('unexpected_response', 'Unerwartete Antwort — bitte erneut versuchen.');
      }
      throw new Error(msg);
    }
    return data.analysis;
  }

  function initProfilePlaceholder(input) {
    if (!input) return;
    input.setAttribute('placeholder', input.getAttribute('placeholder') || 'https://…');
  }

  function initPlatformPicker(form, input) {
    if (!form || !input) return;
    var picker = form.querySelector('[data-sach3-platform-picker]');
    var detected = form.querySelector('[data-sach3-platform-detected]');
    var choices = Array.prototype.slice.call(
      form.querySelectorAll('[data-sach3-platform-choice]')
    );
    if (!choices.length) return;

    function selectDetectedPlatform() {
      var platform = detectPlatform(normalizeUrl(input.value));
      var matchedLabel = '';
      choices.forEach(function (choice) {
        var isMatch = choice.getAttribute('data-sach3-platform') === platform;
        choice.classList.toggle('is-detected', isMatch);
        if (isMatch) {
          matchedLabel =
            choice.getAttribute('data-sach3-platform-label') ||
            String(choice.textContent || '').trim();
        }
      });
      if (!matchedLabel && platform) {
        matchedLabel = PLATFORM_LABELS[platform] || platform;
      }
      if (detected) {
        var template =
          (picker && picker.getAttribute('data-sach3-detected-template')) ||
          '{platform} automatisch erkannt';
        detected.textContent = matchedLabel ? template.replace('{platform}', matchedLabel) : '';
      }
    }

    input.addEventListener('input', selectDetectedPlatform);
    selectDetectedPlatform();
  }

  // Same-origin POST (Shopify App-Proxy → Brain). Kein JSONP mehr.
  async function applyProfile(applyUrl, form) {
    var data = new FormData(form);
    var body = new URLSearchParams();
    data.forEach(function (value, key) {
      body.set(key, String(value || '').trim());
    });
    // Shopify Storefront überschreibt name="email"+type=email Placeholder → name@example.com.
    // Feld heißt daher creator_hub_email; API erwartet weiterhin email.
    if (body.has('creator_hub_email') && !body.get('email')) {
      body.set('email', String(body.get('creator_hub_email') || '').trim());
      body.delete('creator_hub_email');
    }
    var controller = new AbortController();
    var timer = window.setTimeout(function () {
      controller.abort();
    }, 30000);
    var response;
    try {
      response = await fetch(applyUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: body.toString(),
        credentials: 'same-origin',
        signal: controller.signal,
      });
    } catch (e) {
      window.clearTimeout(timer);
      throw new Error(t('connect_retry', 'Verbinden fehlgeschlagen — bitte erneut versuchen.'));
    }
    window.clearTimeout(timer);
    var result;
    try {
      result = await response.json();
    } catch (e) {
      throw new Error(t('unexpected_response', 'Unerwartete Antwort — bitte erneut versuchen.'));
    }
    if (!response.ok || !result || !result.success) {
      var err = (result && result.error) ? result.error : t('connect_failed', 'Verbinden fehlgeschlagen');
      var applyError = new Error(err);
      applyError.code = result && result.code ? String(result.code) : '';
      applyError.status = response.status;
      throw applyError;
    }
    return result;
  }

  function setApplyStatus(form, ok, msg) {
    var statusEl = form && form.querySelector('[data-sach3-apply-status]');
    if (!statusEl) return;
    statusEl.className = 'sach3-apply__status' + (ok ? ' is-ok' : ok === false ? ' is-err' : '');
    statusEl.textContent = msg || '';
  }

  function formatCommission(bp) {
    var value = Number(bp);
    return Number.isFinite(value) ? (value / 100).toLocaleString(LOCALE, { maximumFractionDigits: 2 }) + ' %' : '—';
  }

  function formatEuroCents(cents) {
    var value = Number(cents);
    if (!Number.isFinite(value)) return '—';
    return (value / 100).toLocaleString(LOCALE, { style: 'currency', currency: 'EUR' });
  }

  function setDashboardMetric(root, key, value) {
    var el = root.querySelector('[data-sach3-metric="' + key + '"]');
    if (el) el.textContent = value;
  }

  // Leerzustand als sicheres <p> (kein innerHTML → keine Injection).
  function renderEmpty(container, message) {
    if (!container) return;
    container.textContent = '';
    var p = document.createElement('p');
    p.className = 'sach3__dashboard-empty';
    p.textContent = message;
    container.appendChild(p);
  }

  function renderLoyaltyPanel(root, data) {
    var panel = root.querySelector('[data-sach3-loyalty-panel]');
    var catalog = root.querySelector('[data-sach3-loyalty-catalog]');
    var history = root.querySelector('[data-sach3-loyalty-history]');
    var hint = root.querySelector('[data-sach3-loyalty-hint]');
    if (!panel || !catalog) return;

    var loyalty = data.loyalty || null;
    if (!loyalty) {
      panel.hidden = true;
      return;
    }
    panel.hidden = false;

    if (hint) {
      var next =
        loyalty.nextLevel && loyalty.pointsToNextLevel > 0
          ? ' ' +
            tf('loyalty_next', 'Noch {points} Statuspunkte bis {level}.', {
              points: loyalty.pointsToNextLevel,
              level: loyalty.nextLevel,
            })
          : '';
      hint.textContent =
        tf('loyalty_hint', '100 Rabattpunkte = 1 € Shop-Rabatt. Dein Punkte-Bonus: {mult}×.', {
          mult: String(loyalty.earnMultiplier).replace('.', ','),
        }) +
        next;
    }

    catalog.textContent = '';
    (loyalty.redeemCatalog || []).forEach(function (offer) {
      var row = document.createElement('div');
      row.className = 'sach3__profile-row';
      var label = document.createElement('div');
      label.className = 'sach3__profile-name';
      var title = document.createElement('strong');
      title.textContent = offer.labelDe || offer.sku;
      var meta = document.createElement('span');
      meta.textContent = tf('reward_points', '{points} Rabattpunkte', { points: offer.points });
      label.appendChild(title);
      label.appendChild(meta);
      row.appendChild(label);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sach3__copy-link';
      btn.textContent = !loyalty.redeemEnabled
        ? t('redeem_not_enabled', 'Noch nicht freigeschaltet')
        : offer.affordable
          ? t('redeem', 'Einlösen')
          : t('too_few_points', 'Zu wenig Punkte');
      btn.disabled = !loyalty.redeemEnabled || !offer.affordable;
      if (!loyalty.redeemEnabled) {
        btn.title = t(
          'redeem_not_enabled_hint',
          'Die Punkte-Einlösung wird nach Abschluss der Shopify-Prüfung freigeschaltet.'
        );
      }
      if (loyalty.redeemEnabled && offer.affordable) {
        btn.addEventListener('click', function () {
          redeemLoyaltySku(root, offer.sku, btn);
        });
      }
      row.appendChild(btn);
      catalog.appendChild(row);
    });

    if (history) {
      history.textContent = '';
      var redemptions = data.redemptions || [];
      if (redemptions.length) {
        var h = document.createElement('p');
        h.className = 'sach3__dashboard-empty';
        h.textContent = tf('last_redemption', 'Letzte Einlösung: {code} ({status})', {
          code: redemptions[0].code || redemptions[0].sku,
          status: redemptions[0].status,
        });
        history.appendChild(h);
      }
    }
  }

  function redeemLoyaltySku(root, sku, button) {
    var url = root.getAttribute('data-sach3-dashboard-url');
    if (!url) return;
    button.disabled = true;
    button.textContent = t('redeeming', 'Wird eingelöst …');
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ action: 'redeem', sku: sku }),
    })
      .then(function (res) {
        return res.json().then(function (json) {
          return { ok: res.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok || !result.json || !result.json.success) {
          throw new Error(
            (result.json && result.json.error) || t('redeem_failed', 'Einlösung fehlgeschlagen.')
          );
        }
        var code =
          result.json.data &&
          result.json.data.redemption &&
          result.json.data.redemption.code;
        button.textContent = code ? tf('redeem_code', 'Code: {code}', { code: code }) : t('redeemed', 'Eingelöst');
        loadCreatorDashboard();
      })
      .catch(function (err) {
        button.disabled = false;
        button.textContent = t('redeem', 'Einlösen');
        sach3Notify(err.message || t('redeem_failed', 'Einlösung fehlgeschlagen.'), false);
      });
  }

  function addProfileRow(container, profile) {
    var row = document.createElement('div');
    row.className = 'sach3__profile-row';

    var identity = document.createElement('div');
    identity.className = 'sach3__profile-name';
    var platform = document.createElement('span');
    platform.textContent = profile.platform || t('profile', 'Profil');
    var handle = document.createElement(profile.profileUrl ? 'a' : 'strong');
    handle.textContent = profile.handle || t('connected_profile', 'Verbundenes Profil');
    if (profile.profileUrl) {
      handle.href = profile.profileUrl;
      handle.target = '_blank';
      handle.rel = 'noreferrer';
    }
    identity.appendChild(platform);
    identity.appendChild(handle);
    row.appendChild(identity);

    if (profile.trackingUrl) {
      var copy = document.createElement('button');
      copy.type = 'button';
      copy.className = 'sach3__copy-link';
      copy.setAttribute('data-sach3-copy', profile.trackingUrl);
      copy.textContent = t('copy_link', 'Link kopieren');
      row.appendChild(copy);
    }
    container.appendChild(row);
  }

  function formatCount(value) {
    if (value == null || value === '') return '—';
    var n = Number(value);
    if (!Number.isFinite(n)) return '—';
    if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    return String(Math.round(n));
  }

  function tiktokErrorMessage(code) {
    switch (String(code || '')) {
      case 'tiktok_already_linked':
        return t('tt_err_linked', 'Dieses TikTok-Konto ist bereits mit einem anderen Creator verbunden.');
      case 'oauth_denied':
        return t('tt_err_denied', 'Die TikTok-Freigabe wurde abgebrochen.');
      case 'invalid_state':
        return t('err_expired', 'Die Verbindung ist abgelaufen. Bitte erneut verbinden.');
      case 'missing_params':
        return t('tt_err_params', 'Ungültige Antwort von TikTok. Bitte erneut versuchen.');
      case 'callback_failed':
        return t('err_callback', 'Verbindung fehlgeschlagen. Bitte später erneut versuchen.');
      default:
        return code ? t('tt_err_generic', 'TikTok-Verbindung fehlgeschlagen.') : '';
    }
  }

  function instagramErrorMessage(code) {
    switch (String(code || '')) {
      case 'instagram_already_linked':
        return t('ig_err_linked', 'Dieses Instagram-Konto ist bereits mit einem anderen Creator verbunden.');
      case 'oauth_denied':
        return t('ig_err_denied', 'Die Instagram-Freigabe wurde abgebrochen.');
      case 'invalid_state':
        return t('err_expired', 'Die Verbindung ist abgelaufen. Bitte erneut verbinden.');
      case 'missing_params':
        return t('ig_err_params', 'Ungültige Antwort von Instagram. Bitte erneut versuchen.');
      case 'connect_failed':
        return t('err_callback', 'Verbindung fehlgeschlagen. Bitte später erneut versuchen.');
      default:
        return code ? t('ig_err_generic', 'Instagram-Verbindung fehlgeschlagen.') : '';
    }
  }


  function submissionStatusLabel(status) {
    if (status === 'approved') return t('submission_approved', 'Freigegeben');
    if (status === 'rejected') return t('submission_rejected', 'Abgelehnt');
    return t('submission_pending', 'Wartet auf Prüfung');
  }

  function renderSubmissionsPanel(root, submissions) {
    var mount = root.querySelector('[data-sach3-submissions]');
    if (!mount) return;
    mount.textContent = '';

    var intro = document.createElement('p');
    intro.className = 'sach3__dashboard-empty';
    intro.textContent = t(
      'submission_hint',
      'Nach dem Veröffentlichen den direkten Link zu deinem Post hier einreichen. Wir prüfen ihn manuell.'
    );
    mount.appendChild(intro);

    var form = document.createElement('form');
    form.className = 'sach3__submission-form';
    form.setAttribute('data-sach3-submission-form', '1');

    var platformWrap = document.createElement('label');
    platformWrap.className = 'sach3__submission-field';
    platformWrap.textContent = t('submission_platform', 'Plattform');
    var platform = document.createElement('select');
    platform.name = 'platform';
    ['instagram', 'tiktok', 'youtube', 'facebook', 'pinterest', 'website'].forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      platform.appendChild(option);
    });
    platformWrap.appendChild(platform);
    form.appendChild(platformWrap);

    var urlWrap = document.createElement('label');
    urlWrap.className = 'sach3__submission-field';
    urlWrap.textContent = t('submission_url', 'Post-Link');
    var urlInput = document.createElement('input');
    urlInput.type = 'url';
    urlInput.name = 'postUrl';
    urlInput.required = true;
    urlInput.placeholder = 'https://…';
    urlWrap.appendChild(urlInput);
    form.appendChild(urlWrap);

    var submit = document.createElement('button');
    submit.type = 'submit';
    submit.className = 'sach3__cta sach3__cta--secondary';
    submit.textContent = t('submission_submit', 'Einreichen');
    form.appendChild(submit);
    mount.appendChild(form);

    var list = document.createElement('div');
    list.className = 'sach3__submission-list';
    list.setAttribute('data-sach3-submission-list', '1');
    var items = submissions || [];
    if (!items.length) {
      var empty = document.createElement('p');
      empty.className = 'sach3__dashboard-empty';
      empty.textContent = t('submission_empty', 'Noch keine Beiträge eingereicht.');
      list.appendChild(empty);
    } else {
      items.forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'sach3__submission-row';
        var title = document.createElement('strong');
        title.textContent = String(item.platform || '') + ' · ' + submissionStatusLabel(item.status);
        row.appendChild(title);
        var link = document.createElement('a');
        link.href = item.postUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = item.postUrl;
        row.appendChild(link);
        list.appendChild(row);
      });
    }
    mount.appendChild(list);
  }

  async function submitCreatorPost(root, form) {
    var endpoint =
      root.getAttribute('data-sach3-submissions-url') ||
      '/apps/design-factory/creator-hub/dashboard/submissions';
    var platform = form.platform.value;
    var postUrl = String(form.postUrl.value || '').trim();
    if (!postUrl) return;
    var response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
      body: JSON.stringify({ platform: platform, postUrl: postUrl }),
    });
    var payload = await response.json().catch(function () { return null; });
    if (!response.ok || !payload || !payload.success) {
      var code = payload && payload.code;
      if (code === 'DUPLICATE_URL') {
        throw new Error(t('submission_error_duplicate', 'Dieser Link wurde bereits eingereicht.'));
      }
      if (code === 'INVALID_POST_URL') {
        throw new Error(t('submission_error_profile', 'Bitte den Link zu einem Beitrag einfügen, nicht zum Profil.'));
      }
      throw new Error((payload && payload.error) || t('submission_error_generic', 'Einreichung fehlgeschlagen.'));
    }
    form.reset();
    await loadCreatorDashboard();
  }

  function renderTikTokPanel(root, tiktok, bannerMessage, bannerOk) {
    var mount = root.querySelector('[data-sach3-tiktok]');
    if (!mount) return;
    mount.textContent = '';

    if (bannerMessage) {
      var banner = document.createElement('p');
      banner.className = 'sach3__tiktok-banner ' + (bannerOk ? 'is-ok' : 'is-err');
      banner.textContent = bannerMessage;
      mount.appendChild(banner);
    }

    var data = tiktok || {};
    var status = data.status || 'disconnected';

    if (status === 'disconnected' || status === 'empty' || !data.configured) {
      var empty = document.createElement('p');
      empty.className = 'sach3__dashboard-empty';
      empty.textContent = t('tt_not_connected', 'TikTok noch nicht verbunden.');
      mount.appendChild(empty);
      var hint = document.createElement('p');
      hint.className = 'sach3__tiktok-hint';
      hint.textContent =
        data.permissionsHint ||
        t('tt_permissions', 'Berechtigungen: Profil, Statistiken und öffentliche Videos — keine privaten Nachrichten, kein Posten.');
      mount.appendChild(hint);
      var manual = document.createElement('p');
      manual.className = 'sach3__tiktok-hint';
      manual.textContent = t(
        'tt_manual_mode',
        'TikTok-Verbindung ist derzeit nicht verfügbar. Reiche deine Beiträge manuell über „Beitrag einreichen“ ein.'
      );
      mount.appendChild(manual);
      return;
    }

    var profile = data.profile || {};
    var head = document.createElement('div');
    head.className = 'sach3__tiktok-head';
    if (profile.avatarUrl) {
      var img = document.createElement('img');
      img.className = 'sach3__tiktok-avatar';
      img.alt = '';
      img.src = profile.avatarUrl;
      head.appendChild(img);
    }
    var meta = document.createElement('div');
    meta.className = 'sach3__tiktok-meta';
    var name = document.createElement('strong');
    name.textContent = profile.displayName || profile.username || 'TikTok';
    meta.appendChild(name);
    var handle = document.createElement('span');
    handle.textContent =
      (profile.username ? '@' + String(profile.username).replace(/^@/, '') : 'TikTok') +
      (profile.isVerified ? ' · ' + t('verified', 'verifiziert') : '') +
      (status === 'reauthorization_required' ? ' · ' + t('reauth_needed', 'erneut verbinden nötig') : '');
    meta.appendChild(handle);
    if (data.lastSyncedAt) {
      var sync = document.createElement('span');
      sync.textContent = tf('last_synced', 'Zuletzt synchronisiert: {date}', {
        date: new Date(data.lastSyncedAt).toLocaleString(LOCALE),
      });
      meta.appendChild(sync);
    }
    head.appendChild(meta);
    mount.appendChild(head);

    var stats = document.createElement('div');
    stats.className = 'sach3__tiktok-stats';
    [
      [t('stat_followers', 'Follower'), profile.followerCount],
      [t('stat_likes', 'Likes'), profile.likesCount],
      [t('stat_videos', 'Videos'), data.videoCount != null ? data.videoCount : profile.videoCount],
    ].forEach(function (row) {
      var card = document.createElement('article');
      var label = document.createElement('span');
      label.textContent = row[0];
      var value = document.createElement('strong');
      value.textContent = formatCount(row[1]);
      card.appendChild(label);
      card.appendChild(value);
      stats.appendChild(card);
    });
    mount.appendChild(stats);

    if (data.creatorLink) {
      var linkRow = document.createElement('div');
      linkRow.className = 'sach3__tiktok-actions';
      var copy = document.createElement('button');
      copy.type = 'button';
      copy.className = 'sach3__copy-link';
      copy.setAttribute('data-sach3-copy', data.creatorLink);
      copy.textContent = t('copy_creator_link', 'Creator-Link kopieren');
      linkRow.appendChild(copy);
      mount.appendChild(linkRow);
    }

    var actionRow = document.createElement('div');
    actionRow.className = 'sach3__tiktok-actions';
    if (profile.profileUrl) {
      var open = document.createElement('a');
      open.href = profile.profileUrl;
      open.target = '_blank';
      open.rel = 'noreferrer';
      open.textContent = t('open_profile', 'Profil öffnen');
      actionRow.appendChild(open);
    }
    var syncBtn = document.createElement('button');
    syncBtn.type = 'button';
    syncBtn.setAttribute('data-sach3-tiktok-sync', '1');
    syncBtn.textContent = t('sync_now', 'Jetzt synchronisieren');
    actionRow.appendChild(syncBtn);
    var reconnect = document.createElement('button');
    reconnect.type = 'button';
    reconnect.setAttribute('data-sach3-tiktok-connect', '1');
    reconnect.textContent = status === 'reauthorization_required' ? t('reconnect', 'Erneut verbinden') : t('reconnect_new', 'Neu verbinden');
    actionRow.appendChild(reconnect);
    var disconnect = document.createElement('button');
    disconnect.type = 'button';
    disconnect.className = 'is-danger';
    disconnect.setAttribute('data-sach3-tiktok-disconnect', '1');
    disconnect.textContent = t('disconnect', 'Verbindung trennen');
    actionRow.appendChild(disconnect);
    mount.appendChild(actionRow);

    var videos = Array.isArray(data.videos) ? data.videos : [];
    if (videos.length === 0) {
      var noVideos = document.createElement('p');
      noVideos.className = 'sach3__dashboard-empty';
      noVideos.textContent = t('tt_no_videos', 'Noch keine öffentlichen Videos synchronisiert.');
      mount.appendChild(noVideos);
      return;
    }

    var list = document.createElement('div');
    list.className = 'sach3__tiktok-videos';
    videos.forEach(function (video) {
      var item = document.createElement(video.shareUrl ? 'a' : 'div');
      item.className = 'sach3__tiktok-video';
      if (video.shareUrl) {
        item.href = video.shareUrl;
        item.target = '_blank';
        item.rel = 'noreferrer';
      }
      if (video.coverUrl) {
        var cover = document.createElement('img');
        cover.src = video.coverUrl;
        cover.alt = '';
        item.appendChild(cover);
      } else {
        var placeholder = document.createElement('div');
        placeholder.style.cssText = 'width:72px;height:96px;border-radius:8px;background:#222';
        item.appendChild(placeholder);
      }
      var body = document.createElement('div');
      var title = document.createElement('h4');
      title.textContent = video.title || video.description || t('tt_video', 'TikTok Video');
      body.appendChild(title);
      var metrics = document.createElement('p');
      metrics.textContent = tf('tt_video_metrics', '{views} Views · {likes} Likes · {comments} Kommentare', {
        views: formatCount(video.viewCount),
        likes: formatCount(video.likeCount),
        comments: formatCount(video.commentCount),
      });
      body.appendChild(metrics);
      var badges = document.createElement('div');
      badges.className = 'sach3__tiktok-badges';
      var b1 = document.createElement('span');
      b1.className = video.mentionStrongant ? 'is-on' : '';
      b1.textContent = video.mentionStrongant ? t('badge_brand_on', 'StrongAnt erwähnt') : t('badge_brand_off', 'Keine Marke');
      var b2 = document.createElement('span');
      b2.className = video.mentionCreatorLink ? 'is-on' : '';
      b2.textContent = video.mentionCreatorLink ? t('badge_link_on', 'Creator-Link') : t('badge_link_off', 'Kein Link');
      badges.appendChild(b1);
      badges.appendChild(b2);
      if (video.mentionLogoCover) {
        var b3 = document.createElement('span');
        b3.className = 'is-on sach3__tiktok-badge--logo';
        b3.textContent = t('badge_logo', 'Logo sichtbar');
        badges.appendChild(b3);
      }
      if (video.rewardTier && video.rewardPoints > 0) {
        var b4 = document.createElement('span');
        b4.className = 'sach3__tiktok-badge--points';
        b4.textContent = tf('badge_points', '+{points} Punkte', { points: video.rewardPoints });
        badges.appendChild(b4);
      }
      body.appendChild(badges);
      item.appendChild(body);
      list.appendChild(item);
    });
    mount.appendChild(list);
  }

  function renderInstagramPanel(root, instagram, bannerMessage, bannerOk) {
    var mount = root.querySelector('[data-sach3-instagram]');
    if (!mount) return;
    mount.textContent = '';

    if (bannerMessage) {
      var banner = document.createElement('p');
      banner.className = 'sach3__tiktok-banner ' + (bannerOk ? 'is-ok' : 'is-err');
      banner.textContent = bannerMessage;
      mount.appendChild(banner);
    }

    var data = instagram || {};
    var status = data.status || 'disconnected';

    if (status === 'disconnected' || status === 'empty' || !data.configured) {
      var empty = document.createElement('p');
      empty.className = 'sach3__dashboard-empty';
      empty.textContent = t('ig_not_connected', 'Instagram noch nicht verbunden.');
      mount.appendChild(empty);
      var hint = document.createElement('p');
      hint.className = 'sach3__tiktok-hint';
      hint.textContent =
        data.permissionsHint ||
        t('ig_permissions', 'Berechtigungen: Profil, Insights und öffentliche Beiträge — kein Posten, keine DMs.');
      mount.appendChild(hint);
      var proNote = document.createElement('div');
      proNote.className = 'sach3__ig-pro-note';
      proNote.setAttribute('data-sach3-ig-pro-note', '1');
      var proTitle = document.createElement('strong');
      proTitle.textContent = t(
        'ig_professional_title',
        'Tipp'
      );
      var proBody = document.createElement('p');
      proBody.textContent = t(
        'ig_professional_hint',
        'Falls Instagram nach Creator- oder Business-Konto fragt: kurz in der Instagram-App umstellen, dann hier weiter. Ohne Login geht’s auch mit Profil-Link.'
      );
      proNote.appendChild(proTitle);
      proNote.appendChild(proBody);
      mount.appendChild(proNote);
      var manual = document.createElement('p');
      manual.className = 'sach3__tiktok-hint';
      manual.textContent = t(
        'ig_manual_mode',
        'Instagram-Verbindung ist derzeit nicht verfügbar. Reiche deine Beiträge manuell über „Beitrag einreichen“ ein.'
      );
      mount.appendChild(manual);
      return;
    }

    var profile = data.profile || {};
    var head = document.createElement('div');
    head.className = 'sach3__tiktok-head';
    if (profile.avatarUrl) {
      var img = document.createElement('img');
      img.className = 'sach3__tiktok-avatar';
      img.alt = '';
      img.src = profile.avatarUrl;
      head.appendChild(img);
    }
    var meta = document.createElement('div');
    meta.className = 'sach3__tiktok-meta';
    var name = document.createElement('strong');
    name.textContent = profile.displayName || profile.username || 'Instagram';
    meta.appendChild(name);
    var handle = document.createElement('span');
    handle.textContent =
      (profile.username || 'Instagram') +
      (status === 'reauthorization_required' ? ' · ' + t('reauth_needed', 'erneut verbinden nötig') : '');
    meta.appendChild(handle);
    if (data.lastSyncedAt) {
      var sync = document.createElement('span');
      sync.textContent = tf('last_synced', 'Zuletzt synchronisiert: {date}', {
        date: new Date(data.lastSyncedAt).toLocaleString(LOCALE),
      });
      meta.appendChild(sync);
    }
    head.appendChild(meta);
    mount.appendChild(head);

    if (data.creatorLink) {
      var linkRow = document.createElement('div');
      linkRow.className = 'sach3__tiktok-actions';
      var copy = document.createElement('button');
      copy.type = 'button';
      copy.className = 'sach3__copy-link';
      copy.setAttribute('data-sach3-copy', data.creatorLink);
      copy.textContent = t('copy_creator_link', 'Creator-Link kopieren');
      linkRow.appendChild(copy);
      var syncBtn = document.createElement('button');
      syncBtn.type = 'button';
      syncBtn.setAttribute('data-sach3-instagram-sync', '1');
      syncBtn.textContent = t('ig_sync_posts', 'Beiträge synchronisieren');
      linkRow.appendChild(syncBtn);
      var disconnect = document.createElement('button');
      disconnect.type = 'button';
      disconnect.setAttribute('data-sach3-instagram-disconnect', '1');
      disconnect.textContent = t('disconnect_short', 'Trennen');
      linkRow.appendChild(disconnect);
      mount.appendChild(linkRow);
    }

    var media = data.media || [];
    if (media.length === 0) {
      var noMedia = document.createElement('p');
      noMedia.className = 'sach3__dashboard-empty';
      noMedia.textContent = t('ig_no_posts', 'Noch keine Beiträge synchronisiert.');
      mount.appendChild(noMedia);
      return;
    }

    var list = document.createElement('div');
    list.className = 'sach3__tiktok-videos';
    media.forEach(function (post) {
      var item = document.createElement('article');
      item.className = 'sach3__tiktok-video';
      if (post.thumbnailUrl) {
        var thumb = document.createElement('img');
        thumb.src = post.thumbnailUrl;
        thumb.alt = '';
        item.appendChild(thumb);
      }
      var body = document.createElement('div');
      var title = document.createElement('strong');
      title.textContent = (post.caption || t('ig_post', 'Instagram-Beitrag')).slice(0, 120);
      body.appendChild(title);
      var sales = post.sales || {};
      var salesLine = document.createElement('span');
      salesLine.textContent = tf('post_sales_line', '{orders} Verkäufe · {revenue} Umsatz · {commission} Provision', {
        orders: sales.orderCount || 0,
        revenue: formatEuroCents(sales.salesCents || 0),
        commission: formatEuroCents((sales.commissionCents || 0) + (sales.pendingCommissionCents || 0)),
      });
      body.appendChild(salesLine);
      if (post.trackingUrl) {
        var trackCopy = document.createElement('button');
        trackCopy.type = 'button';
        trackCopy.className = 'sach3__copy-link';
        trackCopy.setAttribute('data-sach3-copy', post.trackingUrl);
        trackCopy.textContent = t('copy_post_link', 'Beitrags-Link kopieren');
        body.appendChild(trackCopy);
      }
      item.appendChild(body);
      list.appendChild(item);
    });
    mount.appendChild(list);
  }

  function renderReceivedProducts(root, products, codes) {
    var panel = root.querySelector('[data-sach3-received-panel]');
    var mount = root.querySelector('[data-sach3-received-products]');
    var codeLine = root.querySelector('[data-sach3-creator-code]');
    if (!panel || !mount) return;

    var rows = Array.isArray(products) ? products : [];
    var activeCodes = Array.isArray(codes)
      ? codes.filter(function (code) { return code && code.kind === 'discount'; })
      : [];
    panel.hidden = rows.length === 0 && activeCodes.length === 0;
    mount.textContent = '';

    rows.forEach(function (product) {
      var card = document.createElement('article');
      card.className = 'sach3__received-product';

      if (product.imageUrl) {
        var image = document.createElement('img');
        image.src = product.imageUrl;
        image.alt = '';
        image.loading = 'lazy';
        card.appendChild(image);
      } else {
        var placeholder = document.createElement('span');
        placeholder.className = 'sach3__received-product-image-placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        placeholder.textContent = '🐜';
        card.appendChild(placeholder);
      }

      var body = document.createElement('div');
      body.className = 'sach3__received-product-body';
      var title = product.productUrl ? document.createElement('a') : document.createElement('strong');
      title.textContent = product.title || 'StrongAnt Produkt';
      if (product.productUrl) {
        title.href = product.productUrl;
        title.target = '_blank';
        title.rel = 'noopener';
      }
      body.appendChild(title);

      var details = [];
      if (product.variant) details.push(product.variant);
      if (product.quantity && Number(product.quantity) > 1) details.push(String(product.quantity) + ' Stück');
      if (product.receivedAt) {
        var parsed = new Date(product.receivedAt + 'T00:00:00');
        if (!Number.isNaN(parsed.getTime())) details.push('Erhalten am ' + parsed.toLocaleDateString('de-DE'));
      }
      if (details.length) {
        var meta = document.createElement('span');
        meta.textContent = details.join(' · ');
        body.appendChild(meta);
      }
      if (product.note) {
        var note = document.createElement('span');
        note.textContent = product.note;
        body.appendChild(note);
      }
      card.appendChild(body);
      mount.appendChild(card);
    });

    if (codeLine) {
      codeLine.textContent = '';
      if (activeCodes.length) {
        codeLine.appendChild(document.createTextNode('Dein dauerhafter Follower-Code: '));
        activeCodes.forEach(function (code, index) {
          if (index) codeLine.appendChild(document.createTextNode(', '));
          var strong = document.createElement('strong');
          strong.textContent = code.code;
          codeLine.appendChild(strong);
        });
        codeLine.hidden = false;
      } else {
        codeLine.hidden = true;
      }
    }
  }

  async function loadCreatorDashboard() {
    var root = document.querySelector('.sach3--landing');
    var dashboard = root && root.querySelector('[data-sach3-dashboard]');
    if (!root || !dashboard) return;

    var url = root.getAttribute('data-sach3-dashboard-url');
    if (!url) return;

    var params = new URLSearchParams(window.location.search);
    var connection = params.get('connection') || '';
    var connectionCode = params.get('code') || '';
    var bannerMessage = '';
    var bannerOk = false;
    if (connection === 'tiktok-success') {
      bannerMessage = t('tt_connected_ok', 'TikTok erfolgreich verbunden.');
      bannerOk = true;
    } else if (connection === 'tiktok-error') {
      bannerMessage = tiktokErrorMessage(connectionCode) || t('tt_err_generic', 'TikTok-Verbindung fehlgeschlagen.');
      bannerOk = false;
    } else if (connection === 'instagram-success') {
      bannerMessage = t('ig_connected_ok', 'Instagram erfolgreich verbunden.');
      bannerOk = true;
    } else if (connection === 'instagram-error') {
      bannerMessage = instagramErrorMessage(connectionCode) || t('ig_err_generic', 'Instagram-Verbindung fehlgeschlagen.');
      bannerOk = false;
    }

    try {
      var response = await fetch(url, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
      });
      if (response.status === 401 || response.status === 403) {
        // Kein signierter App-Proxy / kein Kundenkonto → öffentliche Ansicht.
        dashboard.hidden = true;
        return;
      }
      var payload = await response.json();
      if (!response.ok || !payload || !payload.success) throw new Error(t('dashboard_load_failed', 'Dashboard konnte nicht geladen werden.'));

      clearDashboardError(dashboard);
      dashboard.hidden = false;
      var title = dashboard.querySelector('[data-sach3-dashboard-title]');
      var lead = dashboard.querySelector('[data-sach3-dashboard-lead]');
      var profiles = dashboard.querySelector('[data-sach3-dashboard-profiles]');
      var next = dashboard.querySelector('[data-sach3-dashboard-next]');
      var data = payload.data || {};

      if (!data.creator) {
        if (title) title.textContent = t('welcome_title', 'Willkommen im Creator Hub');
        if (lead) lead.textContent = t('welcome_lead', 'Verbinde dein erstes Profil direkt auf dieser Seite.');
        if (profiles) renderEmpty(profiles, t('no_creator_profile', 'Noch kein Creator-Profil verbunden.'));
        renderTikTokPanel(root, { status: 'disconnected', configured: false }, bannerMessage, bannerOk);
        renderSubmissionsPanel(root, []);
        renderInstagramPanel(root, { status: 'disconnected', configured: false }, bannerMessage, bannerOk);
        if (connection) cleanUrlParams();
        return;
      }

      if (title) title.textContent = tf('hello_creator', 'Hallo {name}', { name: data.creator.displayName || 'Creator' });
      if (lead) lead.textContent = t('dashboard_lead', 'Dein persönliches Creator Dashboard — alles an einem Ort.');
      setDashboardMetric(dashboard, 'level', data.creator.commissionLevel || 'Starter');
      setDashboardMetric(dashboard, 'commission', formatCommission(data.creator.commissionBp));
      setDashboardMetric(dashboard, 'clicks', String((data.metrics && data.metrics.clicks) || 0));
      var loyalty = data.loyalty || {};
      setDashboardMetric(
        dashboard,
        'points',
        String(
          loyalty.rewardPoints != null
            ? loyalty.rewardPoints
            : (data.metrics && data.metrics.pointsBalance) || 0
        )
      );
      setDashboardMetric(
        dashboard,
        'status',
        String(loyalty.statusPointsYear != null ? loyalty.statusPointsYear : '—')
      );
      setDashboardMetric(
        dashboard,
        'multiplier',
        loyalty.earnMultiplier != null ? String(loyalty.earnMultiplier).replace('.', ',') + '×' : '—'
      );
      renderLoyaltyPanel(root, data);

      if (profiles) {
        profiles.textContent = '';
        if (!data.profiles || data.profiles.length === 0) {
          renderEmpty(profiles, t('no_profiles', 'Noch keine Profile verbunden.'));
        } else {
          data.profiles.forEach(function (profile) {
            addProfileRow(profiles, profile);
          });
        }
      }

      renderReceivedProducts(root, data.receivedProducts, data.codes);
      renderSubmissionsPanel(root, data.submissions);
      renderTikTokPanel(root, data.tiktok, connection.indexOf('instagram-') === 0 ? '' : bannerMessage, bannerOk);
      renderInstagramPanel(
        root,
        data.instagram,
        connection.indexOf('tiktok-') === 0 ? '' : bannerMessage,
        bannerOk
      );
      renderExtraPlatforms(dashboard, data.platforms);
      // OAuth-Rückkehr-Parameter nach dem Banner bereinigen (kein Re-Banner bei Reload).
      if (connection) cleanUrlParams();

      if (next) {
        var pending = Number(data.metrics && data.metrics.pendingSubmissions) || 0;
        var igStatus = data.instagram && data.instagram.status;
        var tiktokStatus = data.tiktok && data.tiktok.status;
        var igConfigured = data.instagram && data.instagram.configured;
        var ttConfigured = data.tiktok && data.tiktok.configured;
        if (pending) {
          next.textContent = tf('next_pending', '{count} Content-Einreichung(en) warten auf Prüfung.', { count: pending });
        } else if (!igConfigured && !ttConfigured) {
          next.textContent = t(
            'next_manual_submit',
            'Teile deine Tracking-Links und reiche nach dem Posten deinen Beitrags-Link ein.'
          );
        } else {
          next.textContent = t('next_share', 'Teile deine persönlichen Links und reiche deinen ersten Content ein.');
        }
      }
    } catch (error) {
      // Sichtbarer Fehlerzustand mit Retry statt stillem Ausblenden.
      showDashboardError(
        dashboard,
        error instanceof Error ? error.message : t('dashboard_load_failed', 'Dashboard konnte nicht geladen werden.')
      );
    }
  }

  function clearDashboardError(dashboard) {
    var box = dashboard.querySelector('[data-sach3-dashboard-error]');
    if (box) box.remove();
  }

  function showDashboardError(dashboard, message) {
    dashboard.hidden = false;
    clearDashboardError(dashboard);
    var box = document.createElement('div');
    box.setAttribute('data-sach3-dashboard-error', '');
    box.className = 'sach3__dashboard-error';
    box.setAttribute('role', 'alert');
    var p = document.createElement('p');
    p.textContent = message || t('dashboard_load_failed', 'Dashboard konnte nicht geladen werden.');
    var retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'sach3__btn sach3__btn--ghost';
    retry.textContent = t('retry', 'Erneut versuchen');
    retry.addEventListener('click', function () {
      retry.disabled = true;
      retry.textContent = t('loading', 'Lädt …');
      loadCreatorDashboard();
    });
    box.appendChild(p);
    box.appendChild(retry);
    var host = dashboard.querySelector('[data-sach3-dashboard-profiles]') || dashboard;
    host.parentNode ? host.parentNode.insertBefore(box, host) : dashboard.appendChild(box);
  }

  // Provider-neutrale Karten für zusätzliche Plattformen (alles außer den
  // dedizierten IG/TT-Panels). Neue Plattformen erscheinen automatisch, sobald
  // sie in der Registry aktiv sind — ohne neue Kernkomponenten.
  function renderExtraPlatforms(dashboard, platforms) {
    var host = dashboard.querySelector('[data-sach3-extra-platforms]');
    if (!host) {
      host = document.createElement('section');
      host.setAttribute('data-sach3-extra-platforms', '');
      host.className = 'sach3__dashboard-section sach3__extra-platforms';
      var anchor = dashboard.querySelector('[data-sach3-instagram-panel]') ||
        dashboard.querySelector('[data-sach3-dashboard-profiles]');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(host, anchor.nextSibling);
      else dashboard.appendChild(host);
    }
    host.textContent = '';
    var list = Array.isArray(platforms) ? platforms : [];
    var extra = list.filter(function (p) {
      return p && p.slug !== 'instagram' && p.slug !== 'tiktok';
    });
    if (extra.length === 0) {
      host.hidden = true;
      return;
    }
    host.hidden = false;
    var heading = document.createElement('h3');
    heading.textContent = t('more_platforms', 'Weitere Plattformen');
    host.appendChild(heading);
    var grid = document.createElement('div');
    grid.className = 'sach3__platform-grid';
    extra.forEach(function (p) {
      var card = document.createElement('div');
      card.className = 'sach3__platform-card';
      var name = document.createElement('strong');
      name.textContent = p.displayName || p.slug;
      card.appendChild(name);
      var state = document.createElement('span');
      state.className = 'sach3__platform-state ' + (p.connected ? 'is-connected' : 'is-idle');
      state.textContent = p.connected
        ? t('state_connected', 'verbunden')
        : p.authKind === 'oauth'
          ? t('state_available', 'verfügbar')
          : t('state_manual', 'manuell geführt');
      card.appendChild(state);
      if (p.accounts && p.accounts.length) {
        p.accounts.forEach(function (acc) {
          var row = document.createElement('div');
          row.className = 'sach3__platform-account';
          var h = document.createElement('span');
          h.textContent = acc.handle + (acc.isPrimary ? ' · ' + t('primary', 'Primär') : '');
          row.appendChild(h);
          if (acc.trackingUrl) {
            var copy = document.createElement('button');
            copy.type = 'button';
            copy.className = 'sach3__copy-link';
            copy.setAttribute('data-sach3-copy', acc.trackingUrl);
            copy.textContent = t('copy_link', 'Link kopieren');
            row.appendChild(copy);
          }
          card.appendChild(row);
        });
      }
      grid.appendChild(card);
    });
    host.appendChild(grid);
  }

  document.addEventListener('submit', async function (event) {
    var profileForm = event.target.closest('[data-sach3-profile-form]');
    if (profileForm) {
      event.preventDefault();
      var root = getHubRoot(profileForm);
      if (!root) return;

      var input = profileForm.querySelector('[data-sach3-profile-input]');
      var errorEl = profileForm.querySelector('[data-sach3-profile-error]');
      var result = root.querySelector('[data-sach3-profile-result]');
      var analyzeUrl =
        root.getAttribute('data-sach3-analyze-url') || '/apps/design-factory/creator-hub/analyze';

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (result) result.hidden = true;
      root.querySelector('[data-sach3-apply-panel]') &&
        (root.querySelector('[data-sach3-apply-panel]').hidden = true);
      root.querySelector('[data-sach3-connected-state]') &&
        (root.querySelector('[data-sach3-connected-state]').hidden = true);

      var profileUrl = normalizeUrl(input && input.value);
      var platform = detectPlatform(profileUrl);
      if (!profileUrl || !platform) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent =
            t('invalid_profile_link', 'Bitte einen gültigen Instagram-, TikTok-, YouTube-, Facebook-, Pinterest- oder Website-Link einfügen.');
        }
        return;
      }

      var handle = extractHandle(profileUrl, platform);
      if (!handle) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = t(
            'direct_profile_required',
            'Bitte den direkten Link zu einem Profil statt zu einem Beitrag einfügen.'
          );
        }
        return;
      }
      setLoading(profileForm, true);
      try {
        var analysis = await analyzeProfile(analyzeUrl, {
          profileUrl: profileUrl,
          platform: platform,
          handle: handle,
        });
        renderPreview(root, analysis, { platform: platform, handle: handle, profileUrl: profileUrl });
      } catch (error) {
        if (errorEl) {
          errorEl.hidden = false;
          var errMsg = error instanceof Error ? error.message : t('analyze_failed', 'Analyse fehlgeschlagen');
          if (String(errMsg).toLowerCase().indexOf('expected pattern') >= 0) {
            errMsg = t('unexpected_response', 'Unerwartete Antwort — bitte erneut versuchen.');
          }
          errorEl.textContent = errMsg;
        }
      } finally {
        setLoading(profileForm, false);
      }
      return;
    }

    var applyForm = event.target.closest('[data-sach3-apply-form]');
    if (applyForm) {
      event.preventDefault();
      if (typeof applyForm.checkValidity === 'function' && !applyForm.checkValidity()) {
        if (typeof applyForm.reportValidity === 'function') applyForm.reportValidity();
        return;
      }
      var hubRoot = getHubRoot(applyForm);
      if (!hubRoot) return;
      var applyUrl = hubRoot.getAttribute('data-sach3-apply-url') || '/apps/design-factory/creator-hub/apply';
      setApplyStatus(applyForm, null, t('connecting', 'Wird verbunden…'));
      try {
        var applyResult = await applyProfile(applyUrl, applyForm);
        var msg = (applyResult && applyResult.message) || t('connected_active_short', 'Profil verbunden und freigeschaltet.');
        try {
          window.sessionStorage.removeItem('sach3-pending-apply');
        } catch (storageError) {}
        setApplyStatus(applyForm, true, msg);
        showConnected(hubRoot, msg);
        sach3Notify(msg, true);
        // Erfolg → Dashboard sofort neu laden (Onboarding klappt zu).
        loadCreatorDashboard();
      } catch (error) {
        if (error && (error.code === 'UNAUTHORIZED' || error.status === 401)) {
          try {
            var pending = {};
            new FormData(applyForm).forEach(function (value, key) {
              pending[key] = String(value || '').trim();
            });
            window.sessionStorage.setItem('sach3-pending-apply', JSON.stringify(pending));
          } catch (storageError) {}
          var loginUrl = buildLoginUrl(hubRoot);
          window.location.assign(loginUrl);
          return;
        }
        setApplyStatus(
          applyForm,
          false,
          error instanceof Error ? error.message : t('connect_failed', 'Verbinden fehlgeschlagen')
        );
      }
    }
  });

  document.addEventListener('click', async function (event) {
    var copyBtn = event.target.closest('[data-sach3-copy]');
    if (copyBtn) {
      var value = copyBtn.getAttribute('data-sach3-copy');
      try {
        await navigator.clipboard.writeText(value);
        copyBtn.setAttribute('data-copied', 'true');
        window.setTimeout(function () {
          copyBtn.removeAttribute('data-copied');
        }, 1400);
      } catch (error) {
        console.warn('Copy not available', error);
      }
      return;
    }

    var scrollDash = event.target.closest('[data-sach3-scroll-dashboard]');
    if (scrollDash) {
      var dash = document.querySelector('[data-sach3-dashboard]');
      if (dash) dash.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    var root = document.querySelector('.sach3--landing');
    if (!root) return;

    var connectBtn = event.target.closest('[data-sach3-tiktok-connect]');
    if (connectBtn) {
      var connectUrl =
        root.getAttribute('data-sach3-tiktok-connect-url') ||
        '/apps/design-factory/creator-hub/tiktok/connect';
      connectBtn.disabled = true;
      connectBtn.textContent = t('redirecting', 'Weiterleitung…');
      window.location.href = connectUrl;
      return;
    }

    var syncBtn = event.target.closest('[data-sach3-tiktok-sync]');
    if (syncBtn) {
      var syncUrl =
        root.getAttribute('data-sach3-tiktok-sync-url') ||
        '/apps/design-factory/creator-hub/tiktok/sync';
      syncBtn.disabled = true;
      var prev = syncBtn.textContent;
      syncBtn.textContent = t('syncing', 'Synchronisiere…');
      try {
        var syncRes = await fetch(syncUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store',
        });
        var syncPayload = await syncRes.json();
        if (!syncRes.ok || !syncPayload || !syncPayload.success) {
          throw new Error(
            (syncPayload && syncPayload.error) || t('sync_failed', 'Synchronisierung fehlgeschlagen.')
          );
        }
        await loadCreatorDashboard();
        sach3Notify(t('tt_synced', 'TikTok synchronisiert.'), true);
      } catch (error) {
        sach3Notify(error instanceof Error ? error.message : t('sync_failed', 'Synchronisierung fehlgeschlagen.'), false);
        syncBtn.disabled = false;
        syncBtn.textContent = prev;
      }
      return;
    }

    var disconnectBtn = event.target.closest('[data-sach3-tiktok-disconnect]');
    if (disconnectBtn) {
      if (!(await sach3Confirm(t('tt_disconnect_confirm', 'TikTok-Verbindung wirklich trennen?')))) return;
      var connectionUrl =
        root.getAttribute('data-sach3-tiktok-connection-url') ||
        '/apps/design-factory/creator-hub/tiktok/connection';
      disconnectBtn.disabled = true;
      try {
        var discRes = await fetch(connectionUrl, {
          method: 'DELETE',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store',
        });
        var discPayload = await discRes.json();
        if (!discRes.ok || !discPayload || !discPayload.success) {
          throw new Error((discPayload && discPayload.error) || t('disconnect_failed', 'Trennen fehlgeschlagen.'));
        }
        await loadCreatorDashboard();
        sach3Notify(t('tt_disconnected', 'TikTok-Verbindung getrennt.'), true);
      } catch (error) {
        sach3Notify(error instanceof Error ? error.message : t('disconnect_failed', 'Trennen fehlgeschlagen.'), false);
        disconnectBtn.disabled = false;
      }
      return;
    }

    var igConnectBtn = event.target.closest('[data-sach3-instagram-connect]');
    if (igConnectBtn) {
      var igConnectUrl =
        root.getAttribute('data-sach3-instagram-connect-url') ||
        '/apps/design-factory/creator-hub/instagram/connect';
      igConnectBtn.disabled = true;
      igConnectBtn.textContent = t('redirecting', 'Weiterleitung…');
      window.location.href = igConnectUrl;
      return;
    }

    var igSyncBtn = event.target.closest('[data-sach3-instagram-sync]');
    if (igSyncBtn) {
      var igSyncUrl =
        root.getAttribute('data-sach3-instagram-sync-url') ||
        '/apps/design-factory/creator-hub/instagram/sync';
      igSyncBtn.disabled = true;
      var igPrev = igSyncBtn.textContent;
      igSyncBtn.textContent = t('syncing', 'Synchronisiere…');
      try {
        var igSyncRes = await fetch(igSyncUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store',
        });
        var igSyncPayload = await igSyncRes.json();
        if (!igSyncRes.ok || !igSyncPayload || !igSyncPayload.success) {
          throw new Error(
            (igSyncPayload && igSyncPayload.error) || t('sync_failed', 'Synchronisierung fehlgeschlagen.')
          );
        }
        await loadCreatorDashboard();
        sach3Notify(t('ig_synced', 'Instagram synchronisiert.'), true);
      } catch (error) {
        sach3Notify(error instanceof Error ? error.message : t('sync_failed', 'Synchronisierung fehlgeschlagen.'), false);
        igSyncBtn.disabled = false;
        igSyncBtn.textContent = igPrev;
      }
      return;
    }

    var igDisconnectBtn = event.target.closest('[data-sach3-instagram-disconnect]');
    if (igDisconnectBtn) {
      if (!(await sach3Confirm(t('ig_disconnect_confirm', 'Instagram-Verbindung wirklich trennen?')))) return;
      var igConnectionUrl =
        root.getAttribute('data-sach3-instagram-connection-url') ||
        '/apps/design-factory/creator-hub/instagram/connection';
      igDisconnectBtn.disabled = true;
      try {
        var igDiscRes = await fetch(igConnectionUrl, {
          method: 'DELETE',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store',
        });
        var igDiscPayload = await igDiscRes.json();
        if (!igDiscRes.ok || !igDiscPayload || !igDiscPayload.success) {
          throw new Error((igDiscPayload && igDiscPayload.error) || t('disconnect_failed', 'Trennen fehlgeschlagen.'));
        }
        await loadCreatorDashboard();
        sach3Notify(t('ig_disconnected', 'Instagram-Verbindung getrennt.'), true);
      } catch (error) {
        sach3Notify(error instanceof Error ? error.message : t('disconnect_failed', 'Trennen fehlgeschlagen.'), false);
        igDisconnectBtn.disabled = false;
      }
      return;
    }
  });

  // Sichtbarer Tastatur-Fokus (WCAG 2.4.7). CSS-!important reicht nicht, weil fremde
  // App-Stylesheets (cdn.shopify.com/extensions/...) outline:none per !important erzwingen.
  // Inline-Style mit important-Priorität schlägt jede Stylesheet-Regel – auch Cross-Origin.
  var SACH3_FOCUS_SELECTOR = 'a,button,input,select,textarea,[tabindex]';
  function sach3ApplyFocusRing(el) {
    if (!el || !el.style || !el.matches) return;
    if (!el.matches(SACH3_FOCUS_SELECTOR)) return;
    if (!el.closest || !el.closest('.sach3')) return;
    // Inline + important schlägt jede Stylesheet-Regel, auch Cross-Origin-App-CSS
    // (cdn.shopify.com/extensions/...), die outline:none per !important erzwingt.
    el.style.setProperty('outline', '3px solid #ffb37a', 'important');
    el.style.setProperty('outline-offset', '2px', 'important');
    el.setAttribute('data-sach3-kbfocus', '1');
  }
  function sach3ClearFocusRing(el) {
    if (!el || !el.getAttribute || !el.getAttribute('data-sach3-kbfocus')) return;
    el.style.removeProperty('outline');
    el.style.removeProperty('outline-offset');
    el.removeAttribute('data-sach3-kbfocus');
  }
  function initKeyboardFocusRing() {
    document.addEventListener(
      'focusin',
      function (e) {
        sach3ApplyFocusRing(e.target);
      },
      true
    );
    document.addEventListener(
      'focusout',
      function (e) {
        sach3ClearFocusRing(e.target);
      },
      true
    );
  }

  async function initFromQueryParams() {
    var params = new URLSearchParams(window.location.search);
    var platform = (params.get('platform') || '').toLowerCase();
    var handle = params.get('handle') || '';
    var profileUrl = params.get('profileUrl') || '';
    var level = (params.get('level') || '').toLowerCase();
    if (!platform || !profileUrl) return;

    var root = document.querySelector('.sach3--landing');
    if (!root) return;

    if (handle && handle.charAt(0) !== '@' && platform !== 'website') handle = '@' + handle;

    var input = root.querySelector('[data-sach3-profile-input]');
    if (input) input.value = profileUrl;

    var analyzeUrl =
      root.getAttribute('data-sach3-analyze-url') || '/apps/design-factory/creator-hub/analyze';

    try {
      var analysis = await analyzeProfile(analyzeUrl, {
        profileUrl: profileUrl,
        platform: platform,
        handle: handle,
      });
      if (level && !analysis.level) analysis.level = level;
      renderPreview(root, analysis, { platform: platform, handle: handle, profileUrl: profileUrl });
    } catch (e) {
      fillApplyForm(root, { platform: platform, handle: handle, profileUrl: profileUrl }, { level: level });
      var result = root.querySelector('[data-sach3-profile-result]');
      if (result) {
        result.hidden = false;
        var handleEl = root.querySelector('[data-sach3-result-handle]');
        if (handleEl) handleEl.textContent = handle || profileUrl;
        var platformEl = root.querySelector('[data-sach3-result-platform]');
        if (platformEl) platformEl.textContent = (PLATFORM_LABELS[platform] || platform) + ' · ' + t('detected', 'erkannt');
      }
    }
  }

  function restorePendingApplyAfterLogin() {
    var raw = null;
    try {
      raw = window.sessionStorage.getItem('sach3-pending-apply');
    } catch (storageError) {
      return;
    }
    if (!raw) return;
    var pending;
    try {
      pending = JSON.parse(raw);
    } catch (parseError) {
      window.sessionStorage.removeItem('sach3-pending-apply');
      return;
    }
    if (!pending || !pending.profileUrl) return;

    var profileInput = document.querySelector('[data-sach3-profile-input]');
    var profileForm = profileInput && profileInput.closest('form');
    var applyForm = document.querySelector('[data-sach3-apply-form]');
    if (profileInput) profileInput.value = String(pending.profileUrl);
    if (applyForm) {
      if (applyForm.elements.displayName && pending.displayName) {
        applyForm.elements.displayName.value = String(pending.displayName);
      }
      ['platform', 'handle', 'profileUrl'].forEach(function (name) {
        if (applyForm.elements[name] && pending[name]) {
          applyForm.elements[name].value = String(pending[name]);
        }
      });
    }
    if (profileForm && typeof profileForm.requestSubmit === 'function') {
      window.setTimeout(function () {
        profileForm.requestSubmit();
      }, 0);
    }
  }

  /** Shopify Full-Page mutiert name=email Placeholder zu name@example.com — per data-Attr zurücksetzen. */
  function restoreEmailPlaceholders() {
    document.querySelectorAll('[data-sach3-email-placeholder]').forEach(function (el) {
      var ph = el.getAttribute('data-sach3-email-placeholder');
      if (ph) el.setAttribute('placeholder', ph);
    });
  }

  function prepareLoginLinks() {
    document.querySelectorAll('[data-sach3-login-link]').forEach(function (link) {
      var root = getHubRoot(link);
      if (root) link.href = buildLoginUrl(root);
    });
  }

  function resetOAuthRedirectButtons() {
    document.querySelectorAll('[data-sach3-tiktok-connect],[data-sach3-instagram-connect]').forEach(function (button) {
      button.disabled = false;
      if (button.hasAttribute('data-sach3-tiktok-connect')) {
        button.textContent = t('tt_connect', 'Mit TikTok verbinden');
      } else {
        button.textContent = t('ig_connect', 'Mit Instagram verbinden');
      }
    });
  }

  window.addEventListener('pageshow', resetOAuthRedirectButtons);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetOAuthRedirectButtons();
  });

  document.addEventListener('DOMContentLoaded', function () {
    initKeyboardFocusRing();
    restoreEmailPlaceholders();
    prepareLoginLinks();
    var input = document.querySelector('[data-sach3-profile-input]');
    initProfilePlaceholder(input);
    initPlatformPicker(input && input.closest('[data-sach3-profile-form]'), input);
    if (input && window.matchMedia('(min-width: 721px)').matches) {
      try {
        input.focus({ preventScroll: true });
      } catch (e) {
        input.focus();
      }
    }
    initFromQueryParams();
    restorePendingApplyAfterLogin();
    loadCreatorDashboard();
  });
})();
